import React from 'react';
import IntroPC from "@/page-components/detail/Intro/intro_pc";
import IntroMobile from "@/page-components/detail/Intro/intro_mobile";
import PcComponentWrapper from "@/components/PcComponentWrapper";
import MobileComponentWrapper from "@/components/MobileComponentWrapper";

const Intro: React.FC = () => {
  return (
    <>
      <MobileComponentWrapper>
        <IntroMobile/>
      </MobileComponentWrapper>
      <PcComponentWrapper>
        <IntroPC/>
      </PcComponentWrapper>
    </>
  )
}
export default Intro;
